require('~/pegasus/components/text_field/text_field.js');
require('~/pegasus/components/text_field_with_limit/text_field.js');

Ember.TextField.reopen({
  attributeBindings: ['spellcheck']
});

Pegasus.TextArea = Pegasus.TextField.extend({
  inputType: Ember.TextArea
});

Pegasus.Helpers.prepareInput = function prepareInput(options) {
  var hash = options.hash,
    recordBinding = hash.recordBinding,
    fieldName = hash.fieldName,
    placeholder = hash.placeholder,
    label = hash.label;

  Ember.assert( 'fieldName is required for TextField', fieldName );

  if( ! hash.valueBinding ){
    if( recordBinding ){
      hash.valueBinding = [ recordBinding, fieldName ].join('.');
    } else {
      hash.valueBinding = fieldName;
    }
  }

  if( ! hash.errorsBinding ){
    if( recordBinding ){
      hash.errorsBinding = [ recordBinding, 'errors', fieldName ].join('.');
    } else {
      hash.errorsBinding = ['errors', fieldName ].join('.');
    }
  }

  hash.classNames = hash.classNames || fieldName;
  if (placeholder !== undefined) {
    hash.placeholder = Ember.I18n.knows(placeholder) ? Ember.I18n.t(placeholder) : placeholder;
  }
  if (label !== undefined) {
    hash.label = Ember.I18n.knows(label) ? Ember.I18n.t(label) : label;
  }
};

Pegasus.AlphanumericTextField = Pegasus.TextField.extend({
  focusOut: function() {
    var invalid_characters = "[^a-zA-Z0-9-._ ]",
      imageToolbarController = Pegasus.lookupController('imageToolbar'),
      message, invalid, re;
    re = new RegExp(invalid_characters);

    if (re.test(this.get('value'))) {
      invalid = true;
      if(this.get('fieldName') == "dataName"){
        message = Em.I18n.t('editor.image.name.bad_name');
        if(imageToolbarController.get('content.errors')){
          imageToolbarController.set('content.errors.dataName', [message]);
        }else{
          imageToolbarController.set('content.errors', {dataName: [message]});
        }
      } else {
        message = Em.I18n.t('editor.image.alt_text.bad_name');
        if(imageToolbarController.get('content.errors')){
          imageToolbarController.set('content.errors.dataAlt', [message]);
        } else {
          imageToolbarController.set('content.errors', {dataAlt: [message]});
        }
      }
    }
  }
});

Handlebars.registerHelper('TextField', function(options) {
  Pegasus.Helpers.prepareInput( options );
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.TextField, options);
});

Handlebars.registerHelper('LinkTextField', function(options) {
  Pegasus.Helpers.prepareInput( options );
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.LinkTextField, options);
});

Handlebars.registerHelper('LinkTextFieldAllowEmpty', function(options) {
  Pegasus.Helpers.prepareInput( options );
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.LinkTextFieldAllowEmpty, options);
});

Handlebars.registerHelper('TextFieldWithLimit', function(options) {
  Pegasus.Helpers.prepareInput( options );
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.TextFieldWithLimit, options);
});

Handlebars.registerHelper('AlphanumericTextField', function(options) {
  Pegasus.Helpers.prepareInput( options );
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.AlphanumericTextField, options);
});

Handlebars.registerHelper('TextArea', function(options) {
  Pegasus.Helpers.prepareInput( options );
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.TextArea, options);
});
